import { lazy } from "react";

// project imports
import Loadable from "ui-component/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";
import MainLayout from "layout/MainLayout";

// Master routing
const CreateInstitute = Loadable(
  lazy(() => import("views/instituteRegistration/index")),
);
const PaymentReports = Loadable(
  lazy(() => import("views/report/Payment/index")),
);

// ==============================|| AUTH ROUTING ||============================== //

const AdminRoutes = {
  path: "/",
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "/institute",
      element: <CreateInstitute />,
    },
    {
      path: "/reports/payments-info",
      element: <PaymentReports />,
    },
  ],
};

export default AdminRoutes;
